import React from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { FaFileAlt, FaUser, FaBriefcase, FaCarAlt, FaHome } from 'react-icons/fa';

const ConfirmationForm = ({ 
    isActive, 
    formData, 
    handleChange, 
    handlePrev, 
    isSubmitting,
    vehicleAmount,
    monthlyPayment,
    term 
}) => {
    return (
        <div id="notlar-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaFileAlt className="me-2" /> Başvuru Onayı
            </h4>

            <div className="mb-4 p-3 bg-light rounded">
                <h5>Başvuru Özeti</h5>
                
                <div className="summary-item mt-3">
                    <h6><FaUser className="me-2" /> Kişisel Bilgiler</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Ad Soyad:</strong> {formData.name} {formData.surname}</p>
                            <p><strong>T.C. Kimlik No:</strong> {formData.tcNumber}</p>
                            <p><strong>Doğum Tarihi:</strong> {formData.birthDate}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Telefon:</strong> {formData.phone}</p>
                            <p><strong>E-posta:</strong> {formData.email}</p>
                            <p><strong>Eğitim:</strong> {formData.education}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaBriefcase className="me-2" /> İş Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Meslek:</strong> {formData.occupation}</p>
                            <p><strong>Çalışma Şekli:</strong> {formData.employmentType}</p>
                            <p><strong>Aylık Gelir:</strong> ₺{formData.income}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>İşyeri:</strong> {formData.workplaceName}</p>
                            <p><strong>Çalışma Süresi:</strong> {formData.employmentDuration}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaCarAlt className="me-2" /> Araç Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Marka:</strong> {formData.preferredVehicleBrand}</p>
                            <p><strong>Model:</strong> {formData.preferredVehicleModel}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Model Yılı:</strong> {formData.vehicleYear}</p>
                            <p><strong>Peşinat:</strong> ₺{formData.downPayment}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaHome className="me-2" /> Finansman Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Araç Bedeli:</strong> ₺{vehicleAmount.toLocaleString('tr-TR')}</p>
                            <p><strong>Aylık Ödeme:</strong> ₺{monthlyPayment.toLocaleString('tr-TR')}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Vade:</strong> {term} Ay</p>
                        </Col>
                    </Row>
                </div>
            </div>

            <Form.Group className="mb-3">
                <Form.Label>Ek Notlar / İstekler</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Başvurunuzla ilgili belirtmek istediğiniz diğer hususlar"
                />
            </Form.Group>

            <div className="mb-4">
                <Form.Group className="mb-3">
                    <Form.Check
                        required
                        type="checkbox"
                        id="terms"
                        label={
                            <span>
                                Kişisel verilerimin işlenmesine ilişkin <a href="#" className="text-decoration-underline">aydınlatma metnini</a> okudum ve anladım.
                            </span>
                        }
                        name="hasAcceptedTerms"
                        checked={formData.hasAcceptedTerms}
                        onChange={handleChange}
                        feedback="Bu alanı işaretlemeniz gerekmektedir."
                        feedbackType="invalid"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Check
                        type="checkbox"
                        id="communication"
                        label="Otoprime'dan kampanya, fırsat ve duyuruları e-posta ve SMS yoluyla almak istiyorum."
                        name="hasAcceptedCommunication"
                        checked={formData.hasAcceptedCommunication}
                        onChange={handleChange}
                    />
                </Form.Group>
            </div>

            <div className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={handlePrev}>
                    Geri Dön
                </Button>
                <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    disabled={isSubmitting || !formData.hasAcceptedTerms}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Başvuru İşleniyor...
                        </>
                    ) : (
                        "Başvuruyu Tamamla"
                    )}
                </Button>
            </div>
        </div>
    );
};

export default ConfirmationForm;